import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { MibToastContainer } from '@medinbox/angular';

@Component({
  selector: 'mai-root',
  imports: [RouterOutlet, MibToastContainer],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app.html',
})
export class App {}
